import { render, staticRenderFns } from "./ProductOverview.vue?vue&type=template&id=20fd87d4&"
import script from "./ProductOverview.vue?vue&type=script&lang=js&"
export * from "./ProductOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProductOverview.vue?vue&type=style&index=0&id=20fd87d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports